import { PurchaseStep } from "@modules/purchase/PurchaseStep";
import { CheckCircleIcon, ChevronRightIcon } from "@talladega/icons";
import classNames from "classnames";
import { useTranslation } from "next-i18next";
import { Fragment } from "react";

type Props = {
  steps: PurchaseStep[];
  currentStep: PurchaseStep;
};

const PurchaseStepper = ({ steps, currentStep }: Props) => {
  const { t } = useTranslation(["common", "purchase"]);

  return (
    <div className="mb-8 flex">
      <div className="order-3 flex w-full items-center justify-between sm:hidden sm:order-2">
        <h2 className="text-lg font-bold text-secondary">
          {t(currentStep.nameTranslation)}
        </h2>
      </div>

      <div className="order-3 flex w-full items-center justify-center text-base font-medium sm:order-2 sm:justify-start">
        {steps.map((step) => (
          <Fragment key={step.order}>
            {step.order > 1 && (
              <ChevronRightIcon className="h-5 w-8 text-primary" />
            )}
            <div
              className={classNames("flex", {
                "text-secondary": step.order === currentStep.order,
                "text-quaternary": step.order > currentStep.order,
                "text-text-light-300": step.order < currentStep.order,
              })}
            >
              {step.order < currentStep.order && (
                <CheckCircleIcon className="mr-1.5 h-6 w-6" />
              )}
              {step.order >= currentStep.order && (
                <span
                  className={classNames(
                    "m-0.5 mr-2 flex h-5 w-5 items-center justify-center rounded-full text-center font-medium text-white",
                    {
                      "bg-primary-700": step.order === currentStep.order,
                      "bg-gray-500": step.order > currentStep.order,
                      "bg-text-light-300": step.order < currentStep.order,
                    }
                  )}
                >
                  <span className="mt-0.5">{step.order}</span>
                </span>
              )}
              <span className="hidden sm:block">{t(step.nameTranslation)}</span>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default PurchaseStepper;
